
import Alldoctor from "./doctor/Alldoctor";

export default function DoctorView(){
    return (
        <div>
            <Alldoctor />
        </div>
    )
}